import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { AcceptFatturaElettronicaPassivaModalController } from './accept-fattura-elettronica-passiva-modal';

export const AcceptFatturaElettronicaPassivaModalModule: string = ng
    .module('accept-fattura-elettronica-passiva-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .controller('AcceptFatturaElettronicaPassivaModalController', AcceptFatturaElettronicaPassivaModalController)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/accept-fattura-elettronica-passiva-modal/accept-fattura-elettronica-passiva-modal.module.ts